// extracted by mini-css-extract-plugin
export default {"description":"style_description__Y-bLG","fade-in":"style_fade-in__Qmnrf","top":"style_top__OOa6X","image":"style_image__pbH0y"};